
// Mock data for properties, developers, testimonials.
// All prices in AED (base currency).

export const developers = [
  { id: "emaar", name: "Emaar", tagline: "Iconic Communities" },
  { id: "damac", name: "DAMAC", tagline: "Luxury Living" },
  { id: "aldar", name: "Aldar", tagline: "Abu Dhabi's Premier" },
  { id: "meraas", name: "Meraas", tagline: "Urban Innovation" },
  { id: "sobha", name: "Sobha", tagline: "Crafted Quality" },
  { id: "nakheel", name: "Nakheel", tagline: "Waterfront Pioneers" },
];

export const locations = [
  { id: "downtown", name_en: "Downtown Dubai", name_ar: "وسط مدينة دبي" },
  { id: "palm", name_en: "Palm Jumeirah", name_ar: "نخلة جميرا" },
  { id: "creek", name_en: "Dubai Creek Harbour", name_ar: "مرسى خور دبي" },
  { id: "marina", name_en: "Dubai Marina", name_ar: "مرسى دبي" },
  { id: "yas", name_en: "Yas Island", name_ar: "جزيرة ياس" },
  { id: "saadiyat", name_en: "Saadiyat Island", name_ar: "جزيرة السعديات" },
  { id: "hills", name_en: "Dubai Hills Estate", name_ar: "دبي هيلز إستيت" },
];

export const properties = [
  {
    id: "p1",
    name_en: "The Address Residences Sky View",
    name_ar: "العنوان ريزيدنس سكاي فيو",
    developer: "emaar",
    location: "downtown",
    startingPrice: 2850000,
    handover: 2027,
    roi: "7.8%",
    paymentPlan: "20 / 80 — 20% on booking, 80% on handover",
    bedrooms: "1–4 BR",
    overview_en:
      "A landmark twin-tower residence rising above Downtown, with direct sky-bridge access, a panoramic infinity pool and front-row views of the Burj Khalifa. Designed for the connoisseur who refuses to compromise on location or finish.",
    overview_ar:
      "إقامة برجية مميزة فوق وسط مدينة دبي، مع جسر علوي ومسبح بانورامي وإطلالات أمامية على برج خليفة. مصممة لمن لا يقبل أي تنازل في الموقع أو التشطيب.",
    image: "https://images.pexels.com/photos/1381722/pexels-photo-1381722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: true,
  },
  {
    id: "p2",
    name_en: "Como Residences",
    name_ar: "كومو ريزيدنسز",
    developer: "nakheel",
    location: "palm",
    startingPrice: 21000000,
    handover: 2028,
    roi: "6.5%",
    paymentPlan: "60 / 40 — 60% during construction, 40% post-handover",
    bedrooms: "Half & Full-Floor",
    overview_en:
      "76 storeys of full-floor and half-floor residences on the trunk of Palm Jumeirah, designed by an internationally acclaimed studio. Sea-facing, private pools, and the tallest residence on the Palm.",
    overview_ar:
      "76 طابقاً من الشقق الكاملة ونصف الكاملة على جذع نخلة جميرا، بتصميم استوديو عالمي. إطلالات بحرية، مسابح خاصة، وأطول إقامة على النخلة.",
    image: "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/30554306/pexels-photo-30554306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: true,
  },
  {
    id: "p3",
    name_en: "Creek Beach Lotus",
    name_ar: "كريك بيتش لوتس",
    developer: "emaar",
    location: "creek",
    startingPrice: 1450000,
    handover: 2026,
    roi: "8.2%",
    paymentPlan: "40 / 60 — 40% during construction, 60% post-handover",
    bedrooms: "1–3 BR",
    overview_en:
      "Beach-side living at Dubai Creek Harbour, minutes from the new Creek Tower. Soft palette interiors, podium pool deck, and a curated retail promenade at your doorstep.",
    overview_ar:
      "حياة شاطئية في مرسى خور دبي، على بُعد دقائق من برج الخور الجديد. تصميم داخلي هادئ، مسبح علوي، ومتاجر مختارة عند بابك.",
    image: "https://images.pexels.com/photos/9458996/pexels-photo-9458996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/1381722/pexels-photo-1381722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: true,
  },
  {
    id: "p4",
    name_en: "Cavalli Couture",
    name_ar: "كافالي كوتور",
    developer: "damac",
    location: "marina",
    startingPrice: 19500000,
    handover: 2027,
    roi: "6.1%",
    paymentPlan: "40 / 60 with 1% monthly",
    bedrooms: "3–5 BR",
    overview_en:
      "Ultra-luxury branded residences on the Dubai Water Canal. Every detail signed by Roberto Cavalli — Italian craftsmanship, tropical garden lobby, and a private rainforest spa.",
    overview_ar:
      "إقامات فاخرة بعلامة روبيرتو كافالي على قناة دبي المائية. كل تفصيل بتوقيع إيطالي — لوبي حدائق استوائية، وسبا غابات مطرية خاص.",
    image: "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: false,
  },
  {
    id: "p5",
    name_en: "Yas Acres The Magnolias",
    name_ar: "ياس أيكرز ماجنوليا",
    developer: "aldar",
    location: "yas",
    startingPrice: 4200000,
    handover: 2026,
    roi: "7.4%",
    paymentPlan: "30 / 70 — 30% during construction, 70% on handover",
    bedrooms: "3–6 BR Villas",
    overview_en:
      "Family villas on a championship golf course at Yas Island. Twenty minutes from Abu Dhabi, ten minutes from the beach, and a school district that draws the city's best families.",
    overview_ar:
      "فلل عائلية على ملعب غولف للبطولات في جزيرة ياس. عشرون دقيقة من أبوظبي، وعشر دقائق من الشاطئ.",
    image: "https://images.pexels.com/photos/30554306/pexels-photo-30554306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: false,
  },
  {
    id: "p6",
    name_en: "Sobha Hartland Waves",
    name_ar: "صبحا هارتلاند ويفز",
    developer: "sobha",
    location: "creek",
    startingPrice: 1180000,
    handover: 2026,
    roi: "8.5%",
    paymentPlan: "20 / 40 / 40 — milestone-based",
    bedrooms: "Studio–2 BR",
    overview_en:
      "Compact, beautifully built apartments inside Sobha Hartland — a green community ten minutes from Downtown. A favourite of yield-focused investors.",
    overview_ar:
      "شقق متينة وأنيقة داخل مجتمع صبحا هارتلاند الأخضر، على بعد عشر دقائق من وسط دبي.",
    image: "https://images.pexels.com/photos/9458996/pexels-photo-9458996.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: false,
  },
  {
    id: "p7",
    name_en: "Saadiyat Lagoons",
    name_ar: "بحيرات السعديات",
    developer: "aldar",
    location: "saadiyat",
    startingPrice: 5800000,
    handover: 2027,
    roi: "6.8%",
    paymentPlan: "40 / 60 with handover-linked tranches",
    bedrooms: "4–6 BR Villas",
    overview_en:
      "Mangrove-front villas in Abu Dhabi's cultural capital, next door to the Louvre and Guggenheim. Built for those who want luxury without the noise.",
    overview_ar:
      "فلل بإطلالات على غابات المانغروف في العاصمة الثقافية، بجوار اللوفر والغوغنهايم.",
    image: "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/30554306/pexels-photo-30554306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: false,
  },
  {
    id: "p8",
    name_en: "Bluewaters Bay",
    name_ar: "بلوواترز باي",
    developer: "meraas",
    location: "marina",
    startingPrice: 3200000,
    handover: 2027,
    roi: "7.1%",
    paymentPlan: "20 / 50 / 30 — 30% post-handover",
    bedrooms: "1–4 BR",
    overview_en:
      "Twin-tower waterfront living on Bluewaters Island, beside Ain Dubai. A short stroll to JBR Beach and a private marina at your feet.",
    overview_ar:
      "إقامة برجية على واجهة بحرية في جزيرة بلوواترز بجوار عين دبي، على بُعد دقائق من شاطئ JBR.",
    image: "https://images.pexels.com/photos/30554306/pexels-photo-30554306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    hot: true,
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Priya Subramanian",
    role: "NRI Investor, Mumbai",
    quote:
      "Three agents told me to buy in the same tower. Only one walked me through why I shouldn't. That honesty saved me eighty lakh — and earned a client for life.",
  },
  {
    id: "t2",
    name: "أحمد المنصوري",
    role: "Local Investor, Dubai",
    quote:
      "نصيحة مستقلة، شفافية كاملة، ومتابعة بعد التسليم. هكذا يجب أن تكون الاستشارة العقارية في الإمارات.",
  },
  {
    id: "t3",
    name: "James Whitfield",
    role: "British Expat, Downtown",
    quote:
      "I expected a salesperson and met an advisor. Two years on, my portfolio is up 22% — and I still call him first before any decision.",
  },
  {
    id: "t4",
    name: "Olga Petrova",
    role: "International Investor, Moscow",
    quote:
      "Honest, multilingual, and patient with my questions. He helped me secure a Palm Jumeirah unit at launch — twelve months later it's worth 31% more.",
  },
  {
    id: "t5",
    name: "Khalid Al-Sabah",
    role: "GCC Investor",
    quote:
      "He turned down a developer who tried to put me into the wrong project. That is the agent you want representing you.",
  },
];

export const budgetRanges = [
  { id: "b1", label_en: "Under 1.5M AED", label_ar: "أقل من 1.5 مليون", min: 0, max: 1_500_000 },
  { id: "b2", label_en: "1.5M – 3M AED", label_ar: "1.5 - 3 مليون", min: 1_500_000, max: 3_000_000 },
  { id: "b3", label_en: "3M – 6M AED", label_ar: "3 - 6 مليون", min: 3_000_000, max: 6_000_000 },
  { id: "b4", label_en: "6M – 15M AED", label_ar: "6 - 15 مليون", min: 6_000_000, max: 15_000_000 },
  { id: "b5", label_en: "15M+ AED", label_ar: "أكثر من 15 مليون", min: 15_000_000, max: Infinity },
];

export const handoverYears = [2026, 2027, 2028, 2029];